export default function getViewportWidth(): number {
    let width: number = window.innerWidth;
    // console.log('Got Viewport Width');
    return width;
}
